import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  background-color: white;
  font-size: 12px;
  width: 150px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  padding: 10px;
  box-shadow: 10px 10px 5px -7px rgba(173,170,173,1);

`

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const KeyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
`
const ValueContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`


class BubbleTooltip extends Component {
  renderOptions = () => {
    const { payload } = this.props
    let options = null
    if (payload[0]) {
      options =
        (
          <KeyContainer>
            <ValueContainer>
              <p>
                {`Hora: ${payload[0].payload.hour}`}
              </p>
              <p>
                {`Cantidad: ${payload[0].payload.value}`}
              </p>
            </ValueContainer>
          </KeyContainer>
        )
    }
    return (
      <div>
        <OptionsContainer>
          {options}
        </OptionsContainer>
      </div>
    )
  }

  render() {
    const { active, payload } = this.props
    if (active && payload.length > 0) {
      return (
        <Container>
          {this.renderOptions()}
        </Container>
      )
    }

    return null
  }
}

BubbleTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string,
  suffix: PropTypes.string,
  withoutTotal: PropTypes.bool,
  withoutCurrency: PropTypes.bool,
  prefix: PropTypes.string,
}

BubbleTooltip.defaultProps = {
  active: false,
  payload: [],
  label: '',
  suffix: '',
  withoutTotal: false,
  withoutCurrency: false,
  prefix: '',
}


export default BubbleTooltip



// WEBPACK FOOTER //
// ./src/Components/ReportsComponents/BubbleTooltip.jsx